// ------------------------------------------------------------------
// PURE MODULE: carousel_2.mod.js
// ------------------------------------------------------------------

export function carousel_2(elm, index, radius, currentProgress, totalSlides) {
    
    // --- Safety Check ---
    if (!elm || !totalSlides) return;

    // --- Shared constants ---
    const direction = 1;
    const offset = 2;

    // --- Shared trigonometric math ---
    const theta_transform = (index + offset) / totalSlides - currentProgress;
    
    const sinTheta = Math.sin(theta_transform * Math.PI * 2);
    const cosTheta = Math.cos(theta_transform * Math.PI * 2);
    const rotation = 360 * direction * theta_transform;
	

    // --- Apply transform 
	elm.style.transform = `translate3d(${direction * sinTheta * radius}px, 0px, ${cosTheta * radius}px) rotateY(${rotation}deg) rotateZ(${rotation + 90}deg)`;

}